import React, { useRef, useState } from "react";
import { ReactComponent as InfoIconWhite } from "../../assets/icons/info-white.svg";
import Tooltip from "../Tooltip";

const AcknowledgeInfoBanner = ({
  title = "Acknowledge or update your contact information",
  tooltipText = "Please review your contact information and acknowledge its accuracy, or update any changes if applicable.",
  tooltipClasses = "contact-info",
}) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoRef = useRef(null);

  return (
    <div style={{ padding: "16px 16px 0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          backgroundColor: "#262626",
          borderRadius: "12px",
          padding: "10px 16px",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
        }}
      >
        <span
          style={{
            color: "#fff",
            fontFamily: "FSElliotPro",
            fontSize: "14px",
            fontWeight: 700,
            lineHeight: 1.4,
          }}
        >
          {title}
        </span>
        <Tooltip
          copywriting={tooltipText}
          isActive={showInfo}
          tooltipRef={infoRef}
          additionalClasses={tooltipClasses}
          callback={e => {
            if (e.target?.classList?.contains("tooltip-text")) return;
            setShowInfo(false);
          }}
          anchor={
            <span
              ref={infoRef}
              style={{
                display: "inline-flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={() => setShowInfo(prev => !prev)}
            >
              <InfoIconWhite width={20} height={20} style={{ display: "block" }} />
            </span>
          }
        />
      </div>
    </div>
  );
};

export default AcknowledgeInfoBanner;
